var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('nav',{class:{ sticky: _vm.isSticky }},[_c('div',{staticClass:"navLeft"}),_c('div',{staticClass:"navLogo"},[_c('h1',[_vm._v("SolutionStream")]),_c('router-link',{attrs:{"to":"/"}})],1),_c('div',{staticClass:"navRight"})]),_c('router-view'),_c('DetailView')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }